"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TherapyNote = exports.CaregiverType = exports.Caregiver = exports.Question = exports.SectionContentType = exports.ProcessQuestion = exports.Program = exports.SessionSection = exports.SessionPaymentStatus = exports.SessionType = exports.Session = exports.Section = exports.VideoState = exports.Video = exports.Photo = exports.User = exports.GroupType = exports.BaseModel = exports.modelMapper = exports.ModelTypes = void 0;
const base_model_1 = __importDefault(require("./base-model"));
exports.BaseModel = base_model_1.default;
const group_1 = require("./group");
Object.defineProperty(exports, "GroupType", { enumerable: true, get: function () { return group_1.GroupType; } });
const mappers_1 = __importDefault(require("./mappers"));
const photo_1 = __importDefault(require("./photo"));
exports.Photo = photo_1.default;
const process_question_1 = __importDefault(require("./process-question"));
exports.ProcessQuestion = process_question_1.default;
const program_1 = __importDefault(require("./program"));
exports.Program = program_1.default;
const question_1 = __importDefault(require("./question"));
exports.Question = question_1.default;
const section_1 = __importStar(require("./section"));
exports.Section = section_1.default;
Object.defineProperty(exports, "SectionContentType", { enumerable: true, get: function () { return section_1.SectionContentType; } });
const session_1 = __importStar(require("./session"));
exports.SessionSection = session_1.default;
Object.defineProperty(exports, "Session", { enumerable: true, get: function () { return session_1.Session; } });
Object.defineProperty(exports, "SessionPaymentStatus", { enumerable: true, get: function () { return session_1.SessionPaymentStatus; } });
Object.defineProperty(exports, "SessionType", { enumerable: true, get: function () { return session_1.SessionType; } });
const therapy_1 = __importDefault(require("./therapy"));
exports.TherapyNote = therapy_1.default;
const user_1 = __importStar(require("./user"));
exports.User = user_1.default;
Object.defineProperty(exports, "Caregiver", { enumerable: true, get: function () { return user_1.Caregiver; } });
Object.defineProperty(exports, "CaregiverType", { enumerable: true, get: function () { return user_1.CaregiverType; } });
const video_1 = __importStar(require("./video"));
exports.Video = video_1.default;
Object.defineProperty(exports, "VideoState", { enumerable: true, get: function () { return video_1.VideoState; } });
const models = {
    User: user_1.default,
    Photo: photo_1.default,
    Video: video_1.default,
    Section: section_1.default,
    Session: session_1.Session,
    SessionSection: session_1.default,
    Program: program_1.default,
    ProcessQuestion: process_question_1.default,
    TherapyNote: therapy_1.default,
    ...mappers_1.default,
};
// @ts-ignore
exports.ModelTypes = Object.keys(models).reduce(
// @ts-ignore
(acc, curr) => {
    acc[curr] = curr;
    return acc;
}, {});
function modelMapper(responseType, object) {
    const Model = models[responseType];
    if (Object.getPrototypeOf(Model).prototype === base_model_1.default.prototype) {
        const { data, count = 0, next = null, previous = null, } = object;
        let modeled;
        let meta = {};
        if (Array.isArray(data)) {
            meta = { count, next, previous };
            // @ts-ignore
            modeled = data.map(d => new Model(d));
        }
        else {
            // @ts-ignore
            modeled = new Model(data || object);
        }
        return {
            ...meta,
            [responseType.toLocaleLowerCase()]: modeled,
        };
    }
    if (typeof Model === 'function') {
        // @ts-ignore
        return Model(object);
    }
    console.warn('Response was read without a valid Response Type', object, responseType);
    return object;
}
exports.modelMapper = modelMapper;
exports.default = models;
